import Marquee from "react-fast-marquee";
import { useI18n } from "@/i18n";

export const MarqueeStrip = () => {
  const { t } = useI18n();
  const ITEMS = [t("mq.1"), t("mq.2"), t("mq.3"), t("mq.4"), t("mq.5"), t("mq.6"), t("mq.7"), t("mq.8")];
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-ink-800 py-5"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-mono text-sm uppercase tracking-[0.25em] text-white/50">
              {t}
            </span>
            <span className="text-cyan-neon">✳</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
